import { Fragment, useState, useCallback } from 'react'
import { InputPassword, Icon, Text } from '@leroy-merlin-br/backyard-react-ui'
import { Checkmark } from '@leroy-merlin-br/backyard-react-icons'
import { Controller } from 'react-hook-form'
import { useImmer } from 'use-immer'

import * as validator from 'reactUtils/validators/validators'

import * as S from './styled'

const PasswordField = ({ control, name, ...props }) => {
  const [showChecklist, setShowChecklist] = useState(false)

  const toggleChecklist = () => setShowChecklist(prev => !prev)

  const [rules, setRules] = useImmer([
    {
      message: 'De 8 a 20 caracteres',
      regex: value => validator.isRange(value),
      isValid: false
    },
    {
      message: 'Ao menos uma letra',
      regex: value => validator.isAlphabetic(value),
      isValid: false
    },
    {
      message: 'Ao menos um número',
      regex: value => validator.isNumberPassword(value),
      isValid: false
    },
    {
      message: 'Caracteres fora da sequência',
      regex: value => !validator.hasSequential(value),
      isValid: false
    }
  ])

  const handlePassword = useCallback(
    value => {
      const validate = rules
        .map((validation, index) => {
          setRules(draft => {
            draft[index].isValid = validation.regex(value)
          })

          return validation.regex(value)
        })
        .filter(Boolean)

      if (value === '') {
        return 'Insira sua senha'
      }

      return validate.length === rules.length
    },
    [rules, setRules]
  )

  return (
    <Controller
      name={name}
      rules={{
        validate: value =>
          handlePassword(value) || 'Sua senha não atende aos requisitos'
      }}
      control={control}
      render={({ onChange, ref, value }) => (
        <Fragment>
          <InputPassword
            name={name}
            ref={ref}
            value={value}
            onChange={onChange}
            onFocus={toggleChecklist}
            onBlur={toggleChecklist}
            {...props}
          />

          <S.CheckList spacing="byte" isVisible={showChecklist}>
            <S.Title size="kilo" bold>
              Sua senha deve ter:
            </S.Title>
            {rules.map(({ message, isValid }) => (
              <S.Item
                key={message}
                align="center"
                justify="left"
                spacing="byte"
                isValid={isValid}
              >
                <Icon as={Checkmark} size="kilo" />
                <Text size="kilo" noMargin>
                  {message}
                </Text>
              </S.Item>
            ))}
          </S.CheckList>
        </Fragment>
      )}
    />
  )
}

export default PasswordField
